<script>
  import { events, addDoneTask } from './stores.js';

  let time = 0;
  let startTime = 0;
  let taskType = null;
  let timeout = null;
  let isRunning = false;

  let taskTypes;
  if(IS_DEV) {
    taskTypes = [
      { label: "Pomodoro", duration: 2, isPause: false },
      { label: "Short pause", duration: 2, isPause: true },
      { label: "Long pause", duration: 5, isPause: true },
    ];
  } else {
    taskTypes = [
      { label: "Pomodoro", duration: 25 * 60, isPause: false },
      { label: "Short pause", duration: 5 * 60, isPause: true },
      { label: "Long pause", duration: 15 * 60, isPause: true },
    ];
  }
  function setTaskType(newTaskType) {
    taskType = newTaskType;
    time = newTaskType.duration;
  }
  function start(taskType) {
    setTaskType(taskType);
    startTime = new Date().getTime();
    timeout = setTimeout(update, 0);
    isRunning = true;
  }
  function update() {
    const now = new Date().getTime();
    time = Math.max(Math.round(taskType.duration - (now - startTime) / 1000), 0);
    if (time !== 0) {
      timeout = setTimeout(update, 1000);
    } else {
      timeout = null;
      reset();
      completeTask();
    }
  }
  function reset() {
    isRunning = false;
    if (timeout != null) {
      clearTimeout(timeout);
    }
    setTaskType(taskType);
  }
  function completeTask() {
    addDoneTask(taskType);
    events.set({name: "taskComplete", taskType: taskType});
  }

  function formatTime(s) {
    const m = Math.floor(s / 60);
    s = s % 60;
    return (m < 10 ? "0" : "") + m + ":" + (s < 10 ? "0" : "") + s;
  };

  $: displayTime = formatTime(time)

</script>

<div class="box timer">
  <span class="time">{displayTime}</span>
  <div class="start-buttons">
    {#each taskTypes as task}
      <button
        on:click={() => start(task)}
        disabled={isRunning}
      >Start {task.label}</button>
    {/each}
    <button on:click={reset} disabled={!isRunning}>Cancel</button>
  </div>
  {#if IS_DEV}
    <img
      class="action corner-button"
      src="favicon.png"
      alt="Tomate"
      title="Debug: trigger finish task"
      on:click={completeTask}
    />
  {/if}
</div>

<style>
  @font-face {
    font-family: digits;
    src: url("/digits.woff");
    font-weight: bold;
  }
  .timer {
    text-align: center;
  }
  .timer .time {
    font-family: digits;
    font-size: 10em;
    font-weight: bold;
  }
  .timer .start-buttons {
    display: flex;
    flex-direction: row;
    font-size: 82%;
    margin: 0 -0.5em;
  }
  .timer .start-buttons button {
    flex-grow: 1;
    font-size: inherit;
    margin: 0 0.5em;
  }
</style>